import type { FC, ReactNode } from "react";

import * as styles from "./ProductInformation.styles";

interface Props {
  children: ReactNode;
}

const ProductInformationWrapper: FC<Props> = ({ children, ...rest }) => (
  <div css={styles.productInformation} {...rest}>
    {children}
  </div>
);

export { ProductInformationWrapper };
